export class GoogleObj {
    q: string[];
    target: string;
    }